export const appendEvent = (container, text) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return null;

  const eventContainer = document.createElement('div');
  eventContainer.className = 'aws-chatkit-event';
  eventContainer.textContent = text;
  messages.appendChild(eventContainer);
  messages.scrollTop = messages.scrollHeight;
  return eventContainer;
};
